import {useEffect} from 'react';

import {ACCESS_ROLES} from '../../interfaces/entities/access.interface';
import {Patient} from '../../interfaces/entities/patient.interface';
import {useStores} from '../use-stores';

export const usePatientRole = (
  patientId: Patient['id']
): {
  role?: ACCESS_ROLES;
  isPatientRoleAdmin: boolean;
  isPatientRoleMember: boolean;
  isPatientRoleViewer: boolean;
  loading?: boolean;
} => {
  const {patientsStore: store, authStore} = useStores();

  useEffect(() => {
    store.fetchRole(patientId);
    authStore.fetchMe();
  }, [store.fetchRole, authStore.fetchMe, patientId]);

  const role = store.roles[patientId];

  const isPatientRoleAdmin = role === ACCESS_ROLES.ADMIN;

  const isPatientRoleMember = role === ACCESS_ROLES.MEMBER;

  const isPatientRoleViewer = role === ACCESS_ROLES.VIEWER;

  return {
    role,
    isPatientRoleAdmin,
    isPatientRoleMember,
    isPatientRoleViewer,
    loading: store.loadingRole,
  };
};
